<template>
  <div class="carousel">
    <slot></slot>
    <button class="carousel_nav carousel_next" @click.prevent="next">
      <div class="arrow arrow-right">
        <div></div>
        <div></div>
      </div>
    </button>
    <button class="carousel_nav carousel_prev" @click.prevent="prev">
      <div class="arrow arrow-left">
        <div></div>
        <div></div>
      </div>
    </button>
    <div class="carousel_pagination">
      <button v-for="n in slidesCount" @click="goto(n-1)" :class="{active: n-1 == index}" :key="n"></button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      index: 0,
      slides: [],
      directions: 'right'
    }
  },
  watch: {
    slides (slides) {
      if (this.index >= this.slidesCount) {
        this.index = this.slidesCount
      }
    }
  },
  computed: {
    slidesCount () { return this.slides.length }
  },
  methods: {
    next () {
      this.index++
      this.directions = 'right'
      if (this.index >= this.slidesCount) {
        this.index = 0
      }
    },
    prev () {
      this.index--
      this.directions = 'left'
      if (this.index < 0) {
        this.index = this.slidesCount - 1
      }
    },
    goto (index) {
      this.directions = index > this.index ? 'right' : 'left'
      this.index = index
    }
  },
  mounted () {
    this.slides = this.$children
  }
}
</script>

<style lang="scss">
.carousel{
  margin-top: 2em;
  position: relative;
  overflow: hidden;
  div {
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.carousel_nav {
  position: absolute;
  top: 50%;
  left: 10px;
  margin-top: -31px;
  padding: 0 17px;
  background-color: rgba(#fff, .3);
  border: none;
  border-radius: 100%;
  cursor: pointer;
  .arrow {
    position: relative;
    width: 12px;
    height: 46px;
    div {
      background-color: rgba(#000, .82);
      position: absolute;
      width: 20px;
      height: 4px;
      &:first-child {
        top: -6px;
      }
      &:last-child {
        top: 6px;
      }
    }
  }
  .arrow-right div {
    margin: 20px 0 0 -1px;
    &:first-child {
      transform: rotate(45deg);
    }
    &:last-child {
      transform: rotate(-45deg);
    }
  }
  .arrow-left div {
    margin: 20px 0 0 -5px;
    &:first-child {
      transform: rotate(-45deg);
    }
    &:last-child {
      transform: rotate(45deg);
    }
  }
}
.carousel_nav.carousel_next{
  right: 10px;
  left: auto;
}

.carousel_pagination{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
  button{
    display: inline-block;
    width: 15px;
    height: 15px;
    transform: scale(.6);
    background-color: #000;
    opacity: 0.72;
    border: none;
    border-radius: 100%;
    padding: 2px;
    margin: 0 2px;
    &.active{
      background-color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/Carousel.vue